/**
 * @generated SignedSource<<f31758a7db6250f24b1846fbc210c150>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubscriptionIntroduction_component$data = {
  readonly longtext: string | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "SubscriptionIntroduction_component";
};
export type SubscriptionIntroduction_component$key = {
  readonly " $data"?: SubscriptionIntroduction_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubscriptionIntroduction_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubscriptionIntroduction_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "longtext",
      "storageKey": null
    }
  ],
  "type": "SubscriptionIntroduction",
  "abstractKey": null
};

(node as any).hash = "5eadf7752e271273166c7f13a59cdef3";

export default node;
